var exports = {
  "c": "author__ueMDvN",
  "m": "avatar__GvzApG",
};

module.exports = exports;
